var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.94,
    y: 0.94,
    width: 92.12,
    height: 92.12,
    rx: 46.06,
    fill: "#EBFFE0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.94,
    y: 0.94,
    width: 92.12,
    height: 92.12,
    rx: 46.06,
    stroke: "#98E56C",
    strokeWidth: 1.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.142 43.2976C64.4088 42.2448 63.1116 41.6432 61.6264 41.6432H53.9184C53.4108 41.6432 52.9408 41.4364 52.6212 41.0604C52.2828 40.6844 52.1512 40.158 52.2264 39.6128L53.1852 33.4464C53.5988 31.604 52.3768 29.536 50.5344 28.9156C48.8236 28.2764 46.812 29.1412 46.0036 30.3632L38.07 42.1508L37.8444 42.5268V59.146L38.1264 59.428L44.086 64.034C44.8756 64.8236 46.6616 65.256 47.9212 65.256H55.2532C57.7724 65.256 60.3104 63.3572 60.8744 61.0448L65.4992 46.9636C65.988 45.6288 65.8564 44.3316 65.142 43.2976Z",
    fill: "#159C4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2348 36.4355H32.2984C29.3844 36.4355 28.2 37.5635 28.2 40.3459V59.2587C28.2 62.0411 29.3844 63.1691 32.2984 63.1691H34.2348C37.1488 63.1691 38.3332 62.0411 38.3332 59.2587V40.3459C38.3332 37.5635 37.1488 36.4355 34.2348 36.4355Z",
    fill: "#159C4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLike);
export default __webpack_public_path__ + "static/media/green-like.33c59339e4b645bfa326d634ea52ffbf.svg";
export { ForwardRef as ReactComponent };